import { useEffect, useState } from 'react';
import { useApiKey } from '../state';
import * as sdk from 'fetchfox-sdk';

import { GlobalContext } from '../context/GlobalContext';

export const GlobalProvider = ({ children }) => {
  const apiKey = useApiKey();
  // const user_ = useUser();
  const [fox, setFox] = useState();
  const [user, setUser] = useState();
  const [host, setHost] = useState();

  useEffect(() => {
    console.log('Using API key:', apiKey, sdk);

    if (apiKey) {
      sdk.configure({ apiKey });
      setFox(sdk);
      setHost(sdk.host());
    } else {
      setFox(null);
    }
  }, [apiKey]);

  useEffect(() => {
    setUser(null);
    if (!fox) {
      return;
    }
    fox.user.get().then(setUser);
  }, [fox]);

  const refreshUser = () => fox.user.get().then(setUser);

  return <GlobalContext.Provider value={{ apiKey, user, refreshUser, fox, host }}>{children}</GlobalContext.Provider>;
};
